<div class="container">
  <div class="row no-gutters">
    <div class="col-12">

      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAddManual</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>

      </div>
      <form [formGroup]="addTechnicalManualForm" (ngSubmit)="addTechnicalManuals()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-5 af-form-group">
                  <label for="service" translate>lblBrand <strong class="mlt6 required"> * </strong> </label>
                  <div class='lbl-info'>
                    <ng-select class="" formControlName="brand" placeholder="{{ 'lblSelectBrand' | translate }}"
                      [ngClass]="{'is-invalid': cpf.brand.invalid && cpf.brand.touched}">
                      <option disabled [ngValue]="null" translate>lblBrandRequired</option>
                      <ng-template ng-header-tmp>
                        <span class="mbold w-66px">Code</span>
                        <span class="mbold" translate>lblBrand</span>
                      </ng-template>

                      <ng-option *ngFor="let brand of brandList" [value]="brand.brandCode">
                        <span class="w-66px">{{brand.brandCode}}</span>
                        <span class="mx-2 hide-ng-dropdown-panel">-</span>
                        <span>{{brand.brandName}}</span>
                      </ng-option>
                    </ng-select>
                    <div *ngIf="cpf.brand.invalid && (cpf.brand.dirty || cpf.brand.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.brand.errors.required"><span translate>lblBrandRequired</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="service" translate>lblManualUrl
                    <strong class="mlt6 required"> * </strong> </label>
                  <div class='lbl-info'>
                    <input formControlName="manualUrl" class="form-control mb-2"
                      [ngClass]="{'is-invalid': cpf.manualUrl.invalid && cpf.manualUrl.touched}">
                    <div *ngIf="cpf.manualUrl.touched && (cpf.manualUrl.errors?.required)"
                      class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                        aria-hidden="true"></em>
                      lblManualUrlRequired
                    </div>
                    <div *ngIf="cpf.manualUrl.errors?.pattern" class="help-block mt-1 text-danger" translate> <em
                        class="ft-alert-circle align-middle" aria-hidden="true"></em>
                      lblManualUrlInvalid
                    </div>
                  </div>
                </div>

                <div class="col-12 af-form-group">
                  <div class="lbl-info ml-2">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                      <label class="custom-control-label" for="isActive" translate>lblActive</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button type="submit" class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align"
                [disabled]="!addTechnicalManualForm.valid" translate><em class="far fa-save font16 align-top mr-2"></em>lblSaveChanges</button>
              <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>